module.exports = __webpack_public_path__ + "img/bag-design-tool.21cd6349.png";